export default {
  DRAFT: "draft",
  MAIN: "main",
};
